// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","title":"title-QAfC9","slider":"slider-3xBkx","header":"header-3tX02"};